import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormField } from '../field/FormField';
import Icon from '../icon';
import Progress from '../progress';
import { Size } from '../core/enum';
export default class UploadList extends FormField {
    render() {
        const { prefixCls, props: { items, remove, showPreviewImage, previewImageWidth, }, } = this;
        const list = items.map(file => {
            let previewImg;
            let progress;
            let removeIcon;
            const progressProps = {
                value: file.percent,
                size: Size.small,
                showInfo: false,
            };
            if (showPreviewImage && file.type.startsWith('image')) {
                // temporarily set img[width] to 100
                previewImg = React.createElement("img", { width: previewImageWidth, alt: file.filename, src: file.url });
            }
            if (file.status === 'uploading') {
                progress = (React.createElement("div", { className: `${prefixCls}-item-progress` },
                    React.createElement(Progress, Object.assign({}, progressProps))));
            }
            else {
                const rmProps = {
                    className: classnames(`${prefixCls}-item-icon`, {
                        [`${prefixCls}-item-remove`]: true,
                    }),
                    type: 'close',
                    onClick: () => {
                        remove(file);
                    },
                };
                removeIcon = React.createElement(Icon, Object.assign({}, rmProps));
            }
            const listProps = {
                className: classnames(`${prefixCls}-item`, {
                    [`${prefixCls}-item-error`]: file.status === 'error',
                    [`${prefixCls}-item-success`]: file.status === 'success',
                }),
            };
            return (React.createElement("div", Object.assign({}, listProps, { key: file.uid }),
                previewImg,
                React.createElement("span", { className: `${prefixCls}-item-name` }, file.name),
                progress,
                removeIcon));
        });
        const listWrapperCls = items.length ? `${prefixCls}` : `${prefixCls}-empty`;
        return (React.createElement("div", { className: listWrapperCls }, list));
    }
}
UploadList.displayName = 'UploadList';
UploadList.propTypes = {
    items: PropTypes.array,
    remove: PropTypes.func,
    ...FormField.propTypes,
};
UploadList.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'upload-list',
    items: [],
};
